export interface BusinessModel {
  id: string;
  name: string;
  description: string;
  icon: string;
  transportationMethods: string[];
  categories: TemplateCategory[];
  isActive: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface TemplateCategory {
  id: string;
  name: string;
  description: string;
  icon: string;
  businessModelId: string;
  isActive: boolean;
}

export interface Template {
  id: string;
  name: string;
  description: string;
  businessModelId: string;
  categoryId: string;
  tasks: TemplateTask[];
  defaultTransportationVehicle: string;
  defaultStatusOptions: string[];
  isActive: boolean;
  isDefault: boolean; // For backward compatibility (global default)
  isDefaultForCategory: boolean; // NEW: Default for specific category
  defaultTransportationMethods: string[]; // NEW: Which transport methods this applies to
  createdBy: string;
  createdAt: Date;
  updatedAt: Date;
  usageCount: number;
}

export interface TemplateTask {
  name: string;
  status: string;
  data: string;
  comments: string;
  customStatusOptions?: string[];
}

// Predefined business models structure
export const PREDEFINED_BUSINESS_MODELS = {
  'bulk-commodities-trading': {
    name: 'Bulk Commodities Trading',
    description: 'Bulk, Containerized, Railway shipments',
    icon: '🏭',
    transportationMethods: ['Bulk', 'Containerized', 'Railway'],
    categories: [
      { id: 'soft-commodities', name: 'Soft commodities', description: 'Grains, Oilseeds', icon: '🌾' },
      { id: 'oil-fuels', name: 'Oil & Fuels', description: 'Oil, Gas, Fuels', icon: '⛽' },
      { id: 'construction-materials', name: 'Construction Materials', description: 'Cement, Lumber, Chemicals', icon: '🏗️' },
      { id: 'metallics-steel', name: 'Metallics and Steel Products', description: 'Raw materials, Metals, Products', icon: '🧪' }
    ]
  },
  'ecommerce-retail': {
    name: 'E-Commerce & Retail',
    description: 'Containerized shipments',
    icon: '🛒',
    transportationMethods: ['Containerized'],
    categories: [
      { id: 'amazon-models', name: 'Amazon Models', description: '', icon: '📱' },
      { id: 'shopify-models', name: 'Shopify Models', description: '', icon: '👕' },
      { id: 'dropshipping-models', name: 'Dropshipping Models', description: '', icon: '🏠' }
    ]
  },
  'manufacturing-production': {
    name: 'Manufacturing & Production',
    description: 'General cargo, Containerized, Truck, Railway shipments',
    icon: '🏭',
    transportationMethods: ['General cargo', 'Containerized', 'Truck', 'Railway'],
    categories: [
      { id: 'industrial-equipment', name: 'Industrial Equipment', description: '', icon: '🔧' },
      { id: 'chemical-pharmaceutical', name: 'Chemical & Pharmaceutical', description: '', icon: '🧪' },
      { id: 'automotive-parts', name: 'Automotive & Parts', description: '', icon: '📊' },
      { id: 'construction-engineering', name: 'Construction & Engineering', description: '', icon: '🏗️' }
    ]
  },
  'agency-forwarding-services': {
    name: 'Agency & Forwarding Services',
    description: 'Port agency, freight forwarding, and logistics services',
    icon: '⚓',
    transportationMethods: ['Vessel', 'General cargo', 'Containerized', 'Bulk', 'Truck', 'Railway'],
    categories: [
      { id: 'port-agency-forwarding', name: 'Port Agency & Forwarding', description: 'Port and vessel agency services', icon: '📋' },
      { id: 'trucks-forwarding', name: 'Trucks Forwarding', description: 'Truck freight forwarding services', icon: '📋' },
      { id: 'containers-forwarding', name: 'Containers Forwarding', description: 'Container freight forwarding services', icon: '📋' },
      { id: 'railway-forwarding', name: 'Railway Forwarding', description: 'Railway freight forwarding services', icon: '📋' }
    ]
  }
} as const;

export type BusinessModelId = keyof typeof PREDEFINED_BUSINESS_MODELS;

// Ensure this file is treated as a module
export {};
